<template>
  <div>
    <vx-card class="mt-5">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <div class="flex flex-wrap items-center">
              <p class="card-sub-title mr-3">
                Configurar inversión automática con cargo a tarjeta
              </p>
            </div>
            <small>(Cargo mensual a tarjeta de crédito/débito)</small>
          </div>
          <p>Define tus preferencias para la inversión automática.
            El saldo que se cargue a tu tarjeta será invertido automáticamente.
            <br>
            Puedes definir el monto, día de cargo y el máximo número de reintentos del cargo.</p>
        </div>
      </div>

      <template>
        <div class="vx-row mt-6 mb-4">
          <div class="vx-col w-full ">
            <h5>Establece tus preferencias para inversión con cargo a tarjeta:</h5>
            <vs-alert v-if="onError" color="danger" class="mt-3 mb-3" style="height: auto">{{ errorMssg }}</vs-alert>
          </div>
        </div>

        <div class="vx-row mt-6 mb-base">
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="bold mb-2">1. Monto a invertir automáticamente</p>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <vs-input
              class="investment-input w-full"
              type="text"
              v-model.lazy="cardInvestmentMoney"
              v-money="money"
              name="cardInvestmentMoney"
              v-validate="'required'"
              :min="1"
              icon-pack="feather"
              icon="icon-dollar-sign"
              autocomplete="off"
              disabled
              placeholder="Monto a invertir" />
          </div>
        </div>

        <div class="vx-row mt-6 mb-base">
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="bold mb-2">2. ¿Qué día del mes deseas que se haga el cargo?</p>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <v-select
              name="cardInvestmentDay"
              class="vs-custom w-full"
              v-model.lazy="cardInvestmentDay"
              v-validate="'required'"
              :options="daysCollection"
              :reduce="item => item.value"
              :clearable="false"
              :searchable="false"
              disabled
              placeholder="Selecciona" >
              <div slot="no-options">No hay coincidencias</div>
            </v-select>
          </div>
        </div>

        <div class="vx-row mt-6 mb-base">
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="bold mb-2">3. ¿Cuántos intentos deseas que se realicen, en caso de que el cargo no sea exitoso?</p>
          </div>
          <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <v-select
              name="cardInvestmentRetryCount"
              class="vs-custom w-full"
              v-model.lazy="cardInvestmentRetryCount"
              v-validate="'required'"
              :options="retryCollection"
              :reduce="item => item.value"
              :clearable="false"
              :searchable="false"
              disabled
              placeholder="Selecciona" >
              <div slot="no-options">No hay coincidencias</div>
            </v-select>
          </div>
        </div>

        <div class="vx-row mt-6 mb-base">
          <div class="vx-col w-full">
            <p class="bold mb-2">
              4. Selecciona la tarjeta con la que deseas que se hagan los cargos automáticos, o agrega otra tarjeta.
            </p>
          </div>
          <div class="vx-col lg:w-2/3 md:w-3/4 sm:w-full w-full">
            <div id="data-list-card-view" class="data-list-container">
              <vs-table class="mt-5" ref="cardsTable" v-model="cardRowSelected" :data="formattedCards" noDataText="No hay tarjetas disponibles">
                <template slot="thead">
                  <vs-th class="bold">Tarjeta</vs-th>
                  <vs-th class="bold">Banco</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <div class="flex items-center">
                        <img :src="cardImgSource(tr.thumb)" alt="card" class="card-thumbnail">
                        <p class="font-large pl-4">
                          {{ tr.brand }} que termina en <span class="bold">{{ tr.number }}</span>
                        </p>
                      </div>
                    </vs-td>
                    <vs-td class="calif-container">
                      <p class="font-medium">{{tr.typeFormat}} {{tr.bank}}</p>
                    </vs-td>
                    <vs-td>
                      <span v-if="!isCardSelected(tr) && isSelectable(tr) && !isExpired(tr)" class="text-sm text-primary"></span>
                      <span v-if="!isSelectable(tr) && !isExpired(tr)" class="text-sm text-danger">No disponible</span>
                      <span v-if="isExpired(tr)" class="text-sm text-danger">Expirada</span>
                      <span v-if="isCardSelected(tr)" class="flex items-center">
                        <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 text-success" class="mr-2" />
                        <span class="text-sm text-success bold">Elegida</span>
                      </span>
                    </vs-td>
                  </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex">
              <vs-button type="border" class="ml-6 mt-2" @click="cancel">Regresar</vs-button>
            </div>
          </div>
        </div>
      </template>

    </vx-card>
  </div>
</template>

<script>
import {VMoney} from 'v-money'
import cardsHelper from "@mixins/cardsHelper";
import currencyHelper from "@mixins/currencyHelper";
export default {
  name: "MonthlyAutoInvest",
  props: {
    investorPlan: { type: Object, required: true },
    InvestorId: {
      type: [String,Number],
      required: true
    },
    UserId: {
      type: [String,Number],
      required: true
    }
  },
  mixins: [cardsHelper, currencyHelper],
  directives: {money: VMoney},
  components: {
  },
  data(){
    return {
      cardInvestmentMoney: this.investorPlan.card_amount,
      cardInvestmentDay: null,
      cardInvestmentRetryCount: null,
      daysCollection: [],
      retryCollection: [],
      userCards: [],
      formattedCards: [],
      cardRowSelected: null,
      cardIdSelected: null,
      acceptsOnlyDebit: false,
      preselectedCardId: null,
      preselectedCardDescription: null,
      cardIdToDelete: null,
      createdCardId: null,

      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },

      onError: false,
      errorMssg: null,
    }
  },
  async beforeMount(){
    this.showLoading(true)
    await this.getUserCards();
    this.setCollections();
    this.setDefaults();
    this.showLoading(false)
  },
  methods: {
    setDefaults(){
      this.cardInvestmentDay = this.investorPlan.monthly_day;
      this.cardInvestmentRetryCount = this.investorPlan.retry;

      // pre-seleccionar tarjeta
      if(this.investorPlan.card_id != null){
        this.cardIdSelected = this.investorPlan.card_id;
        this.cardRowSelected = this.formattedCards.find(f => f.id === this.investorPlan.card_id);
      }
    },
    runValidations(){
      let amount = this.unMoneyFormat(this.cardInvestmentMoney);
      if(!this.validateAmount(amount)){
        this.errorMssg = "Por favor ingresa un monto a invertir válido";
        return false;
      }
      if(this.cardInvestmentDay === null ){
        this.errorMssg = "Debes seleccionar un día para el cargo.";
        return false;
      }
      if(this.cardInvestmentRetryCount === null ){
        this.errorMssg = "Debes seleccionar la cantidad de intentos en caso de cargos fallidos.";
        return false;
      }
      if(this.cardIdSelected === null ){
        this.errorMssg = "Debes seleccionar una tarjeta.";
        return false;
      }

      return true;
    },
    validateAmount(amount){
      return amount > 0;
    },
    async cancel(){
      await this.$emit('on-cancel');
    },
    getCardTermination(card){
      if(card && card.length && card.length >= 4){
        return card.substr(card.length - 4);
      }
      return  "";
    },
    setCollections(){
      let c = [];
      for (let i = 1; i <= 28; i++) {
        c.push({value: i, label: i});
      }
      this.daysCollection = c;

      let r = [];
      for (let i = 1; i <= 4; i++) {
        r.push({value: i, label: i});
      }
      this.retryCollection = r;
    },
    async getUserCards(){
      try {
        const res = await axios.get(`api/user/cards/getWithExpirationInfo/${this.UserId}`);
        let cards = res.data;
        let fcards = [];
        cards.forEach(f => {
          let card = f.card;
          let ct = this.getCardTermination(card.card_number);
          fcards.push({
            id: card.id,
            number: ct,
            brand: this.cardBrandName(card.card_brand),
            thumb: this.cardThumbail(card.card_brand),
            typeFormat: this.cardTypeFormat(card.card_type),
            type: card.card_type,
            bank: card.bank_name,
            expirationStatus: f.expiration_status,
            selected: false});
        });
        this.formattedCards = fcards;
      }
      catch (e) {
        this.warn(e);
      }
    },
    cardImgSource(thumb){
      return require(`@assets/images/cards/${thumb}.png`);
    },
    isCardSelected(tr){
      return tr.id === this.cardIdSelected;
    },
    isSelectable(tr){
      if(this.acceptsOnlyDebit){
        return this.isDebitCard(tr.type);
      }
      return true;
    },
    isExpired(tr){
      return tr.expirationStatus === 'expired'
    },
    clean(){
      this.onError = false
      this.errorMssg = null
    },
  },
}
</script>


<style lang="scss">
#data-list-card-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 10px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
          &.img-container {

            span {
              display: flex;
              justify-content: flex-start;
            }
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
